import { lookupQueryKeys } from "data/lookup/lookupQueries";
import { useMutation, useQuery, useQueryClient } from "react-query";
import http from "shared/http";

export interface Role {
  id: number;
  name: string;
  externalSsoGroupId?: string;
  usersIds: number[];
  resources: string[];
}

export interface RoleUser {
  id: number;
  firstname: string;
  lastname: string;
}

export interface RoleResource {
  id: number;
  name: string;
}

// export interface UpsertRolePayload {
//   id?: number;
//   name: string;
//   userIds: number[];
//   resources: string[];
// }

export const useUpsertRoleMutation = () => {
  const queryClient = useQueryClient();
  return useMutation(
    async (role: Role) => {
      if (role.id && role.id > 0) {
        return http.putAsync(`admin/roles/${role.id}`, role);
      }
      return http.postAsync("admin/roles", role);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(lookupQueryKeys.allRoles);
      },
    },
  );
};

export const useGetUsersForRoleQuery = (roleId: number) => {
  return useQuery(
    ["roles", "users", roleId],
    async (): Promise<{ available: RoleUser[]; assigned: RoleUser[] }> => {
      return await http.fetchAsync(`admin/roles/${roleId}/users`);
    },
    {
      //staleTime: 30 * 1000,
    },
  );
};

export const useGetResourcesForRoleQuery = (roleId: number) => {
  return useQuery(
    ["roles", "resources", roleId],
    async (): Promise<{
      available: RoleResource[];
      assigned: RoleResource[];
    }> => {
      return await http.fetchAsync(`admin/roles/${roleId}/resources`);
    },
    {
      //staleTime: 5 * 1000,
    },
  );
};
